/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type MxCallFragment = { __typename: 'MxCall', id: string, incomingNumber: string, outgoingNumber: string, isProcessed: boolean, startTime: any, endTime: any, type?: Types.MxCallType | null, status?: Types.MxCallStatus | null, source?: Types.MxCallSource | null, crmCompany?: { __typename: 'CrmCompany', id: string, title: string, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null } | null, category?: { __typename: 'Category', id: string, name: string } | null };

export const MxCallFragmentDoc = gql`
    fragment MxCall on MxCall {
  id
  incomingNumber
  outgoingNumber
  crmCompany {
    id
    title
    contactPerson {
      id
      fullname
    }
  }
  isProcessed
  startTime
  endTime
  type
  status
  source
  category {
    id
    name
  }
}
    `;